import { message, Popconfirm, Table, Tooltip } from 'antd';
import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { AuthData } from '../../../../Components/Global';
import { encrypt } from '../../../../Utils/CryptoHelper';
import { CheckCircleOutlined, SendOutlined } from '@ant-design/icons';
import { PostOrderEmail } from '../../../../API/PostData';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const SampleOrder = ({ dataSource }) => {

  const Auth = AuthData();
  const AccountId = Auth?.AccountId;
  const Role = Auth?.Role;

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleSendEmail = async (record) => {
    try {
      const payload = {
        AccountId: AccountId,
        OrderCode: record.OrderCode,
        RFNumber: record.RFNumber,
      };
      const res = await PostOrderEmail(payload);
      if (res.status === 200) {
        message.success(res.data.message);

        // Update baris tertentu
        setData((prevData) =>
          prevData.map((item) =>
            item.RFNumber === record.RFNumber
              ? { ...item, OCSendDate: dayjs().format("YYYY-MM-DD HH:mm") }
              : item
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  const fetchData = useCallback(async () => {
    try {
      if (dataSource && dataSource.RFNumber) {
        const grouped = dataSource.RFNumber.map((item, index) => ({
          ...item,
          Sample: dataSource.Sample.filter((sm) => sm.RFNumber === item.RFNumber),
          key: index + 1,
        }));

        setData(grouped);
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, [dataSource]);



  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      key: "RFNumber",
      title: "RF Number",
      dataIndex: "RFNumber",
      sorter: (a, b) => a.RFNumber.localeCompare(b.RFNumber),
    },
    {
      key: "OCSendDate",
      title: "Email Sent Date",
      dataIndex: "OCSendDate",
      sorter: (a, b) => a.OCSendDate.localeCompare(b.OCSendDate),
      render: (date) => date ? dayjs.utc(date).format("YYYY-MM-DD HH:mm:ss") : '-'
    },
  ]

  if (Role === "Admin") {
    columns.push({
      key: "Action",
      title: "Action",
      fixed: "right",
      dataIndex: "Action",
      width: 100,
      render: (value, record) => {
        return (
          <div className="flex justify-around items-center">
            <Popconfirm
              placement="topRight"
              title="Send Email Confirmation"
              description={
                <p>
                  Are you sure you want to send an email to{" "}
                  <span className="font-medium">{record.RFNumber}</span>?
                </p>
              }
              onConfirm={() => handleSendEmail(record)}
              okText="Yes"
              cancelText="No"
            >
              <SendOutlined className="text-second" />
            </Popconfirm>

            {record.OCSendDate && (
              <Tooltip title="Order Confirmation Sent">
                <div className="text-second text-center text-lg">
                  <CheckCircleOutlined />
                </div>
              </Tooltip>
            )}

          </div>
        )
      }
    })
  }


  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        loading={isLoading}
        expandable={{
          expandedRowRender
        }}
        scroll={{
          x: 'max-content',
        }}
      />
    </>
  )
}

export default SampleOrder


const expandedRowRender = (record) => {

  const dataSample = record.Sample;

  const columnSample = [
    {
      key: "SampleNumber",
      title: "Sample Number",
      dataIndex: "SampleNumber",
      sorter: (a, b) => a.SampleNumber.localeCompare(b.SampleNumber),
      render: (value, record) =>
        <Link
          to={`/dashboard/menuorder/sample/${encodeURIComponent(encrypt(record.AccountId))}/${encodeURIComponent(encrypt(record.SampleCode))}`}
          className="text-second hover:text-second-400 font-medium">
          {value}
        </Link>
    },
    {
      key: "SampleName",
      title: "Sample Name",
      dataIndex: "SampleName",
      sorter: (a, b) => a.SampleName.localeCompare(b.SampleName),
    },
    {
      key: "COADueDate",
      title: "COA Due Date",
      dataIndex: "COADueDate",
      sorter: (a, b) => a.COADueDate.localeCompare(b.COADueDate),
    },
    {
      key: "CustomerName",
      title: "Customer Name",
      dataIndex: "CustomerName",
      sorter: (a, b) => a.CustomerName.localeCompare(b.CustomerName),
    },
    {
      key: "ServiceType",
      title: "Service Type",
      dataIndex: "ServiceType",
      sorter: (a, b) => a.ServiceType.localeCompare(b.ServiceType),
      render: (value) => {
        return value ? value : <p>-</p>;
      }
    },
    {
      key: "Description",
      title: "Description",
      dataIndex: "Description",
      sorter: (a, b) => a.Description.localeCompare(b.Description),
      render: (value) => {
        return value ? value : <p>-</p>;
      }
    }
  ];


  return (
    <Table
      columns={columnSample}
      dataSource={dataSample}
      scroll={{
        x: 'max-content'
      }}
    />
  )
}
